import { Type } from '@angular/core'

import { Layout } from 'app/core/cms/type-unions'

import { CmsBlock } from '../cms-block'
import { LayoutAccordionComponent } from './layout-accordion/layout-accordion.component'
import { LayoutCardCarouselComponent } from './layout-card-carousel/layout-card-carousel.component'
import { LayoutCardsGridComponent } from './layout-cards-grid/layout-cards-grid.component'
import { LayoutGalleryComponent } from './layout-gallery/layout-gallery.component'
import { LayoutTestimonialsComponent } from './layout-testimonials/layout-testimonials.component'

type LayoutMapping = {
  [key in Layout['__typename']]: Type<CmsBlock<Layout & { __typename: key }>>
}

export const LAYOUT_MAPPING = {
  LayoutAccordion: LayoutAccordionComponent,
  LayoutCardCarousel: LayoutCardCarouselComponent,
  LayoutTestimonials: LayoutTestimonialsComponent,
  LayoutGallery: LayoutGalleryComponent,
  LayoutCardsGrid: LayoutCardsGridComponent,
} as const satisfies LayoutMapping
